import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const addCommentarySection = api(async function addCommentarySection({ title, description, content }) {
    return mutate(
        gql`
            mutation AddCommentarySection($title: String!, $description: String, $content: String) {
                addCommentarySection(title: $title, description: $description, content: $content)
            }
        `,
        { title, description, content },
        { returns: "addCommentarySection" }
    )
})
